import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development'
    ? '/voip/api'
    : `${process.env.VUE_APP_VOIP_URL}/api`
})

export const apiVoip = {
  Community: {
    /**
     * 查詢軟體門口機是否有「智生活雲對講 Air 合約」，僅需 PublicCode
     * @param {*} data
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Community/post_api_Community_SoftwareEntryPoint_Status}
     */
    GetStatus: (data) =>
      instance.post('/Community/SoftwareEntryPoint/Status', data),

    /**
     * 驗證訪客地理位置是否在 200 公尺範圍內，成功回傳 GeolocationToken + ExpireAtUtc
     * @param {*} data
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Community/post_api_Community_SoftwareEntryPoint_GeolocationValidation}
     */
    ValidateGeolocation: (data) =>
      instance.post('/Community/SoftwareEntryPoint/GeolocationValidation', data),

    /**
     * 取得可撥打對象列表，以 GuestToken 驗權
     * @param {*} data
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Community/post_api_Community_SoftwareEntryPoint_Callees}
     */
    GetCallees: (data) =>
      instance.post('/Community/SoftwareEntryPoint/Callees', data),

    /**
     * 取得 SIP 連線憑證（username、domain、WS 位址），以 GuestToken 驗權
     * @param {*} data { GuestToken: "string"}
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Community/post_api_Community_SoftwareEntryPoint}
     */
    GetSipConfig: (data) =>
      instance.post('/Community/SoftwareEntryPoint', data)
  },

  Guest: {
    /**
     * 取得現場登記表單資料（訪客事由 + 棟/樓/戶結構 + 社區名稱）
     * @param {*} data { GeolocationToken: "string"}
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Guest/post_api_Guest_OnSiteRegisterFormInfo}
     */
    GetOnSiteRegisterFormInfo: (data) =>
      instance.post('/Guest/OnSiteRegisterFormInfo', data),

    /**
     * 查詢指定 Subscriber 是否在線（Location 非 null 且未過期代表在線）
     * @param {string|number} id SubscriberId
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Guest/post_api_Guest_Subscriber__Id__Location}
     */
    GetSubscriberLocation: (id, data) =>
      instance.post(`/Guest/Subscriber/${id}/Location`, data),

    /**
     * 已登記訪客通道：以驗證碼抵達，回傳 GuestToken
     * @param {*} data
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Guest/post_api_Guest_ArrivedInfo}
     */
    ArrivedInfo: (data) =>
      instance.post('/Guest/ArrivedInfo', data),

    /**
     * 現場登記訪客通道：建立訪客紀錄並抵達，回傳 GuestToken
     * @param {*} data
     * @swagger {@link https://voip-dev.kingnetsmart.com.tw/swagger/index.html#/Guest/post_api_Guest_CreateAndArrived}
     */
    CreateAndArrived: (data) =>
      instance.post('/Guest/CreateAndArrived', data)
  }
}
